
/**
 * PageNo: 
 * 999：查询所有
 * 1: digitalPayment BDO支付产品页面一
 * 2: physicalPayment BDO支付产品页面二
 * 3: homeAddress HomeAddress（Individual、Sole Proprietorship）
 * 4: additionalDetails 个人详细信息（Individual、Sole Proprietorship）
 * 5: businessDetails 商户详情
 * 6: businessAddress 商户地址
 * 7: businessOwnership 商户股权（Corporation、Partnership）
 * 8: businessauthorizedSignatories 商户授权签字人（Corporation、Partnership）
 * 9: businessOnlineStore 网上商店的详细信息（Individual、Sole Proprietorship）
 * 10: settlementAccount BDO账户信息
 * 11: selfieWithIDPhoto 身份证信息
 * 12: dtiPhoto DTI图片 （Sole Proprietorship）
 * 13: secPhoto SEC图片（Corporation、Partnership）
 * 14: storePhoto 店铺图片
 * 15: bdoBusinessDetails 已经有BDO账号注册
 */
const pageNoMap = {
  '1': 'digitalPayment',               // BDO支付产品页面一
  '2': 'physicalPayment',              // BDO支付产品页面二
  '3': 'homeAddress',                  // HomeAddress（Individual、Sole Proprietorship）
  '4': 'additionalDetails',            // 个人详细信息（Individual、Sole Proprietorship）
  '5': 'businessDetails',              // 商户详情
  '6': 'businessAddress',              // 商户地址
  '7': 'businessOwnership',            // 商户股权（Corporation、Partnership）
  '8': 'businessauthorizedSignatories',// 商户授权签字人（Corporation、Partnership）
  '9': 'businessOnlineStore',          // 网上商店的详细信息（Individual、Sole Proprietorship）
  '10': 'settlementAccount',           // BDO账户信息
  '11': 'selfieWithIDPhoto',           // 身份证信息
  '12': 'dtiPhoto',                    // DTI图片 （Sole Proprietorship）
  '13': 'secPhoto',                    // SEC图片（Corporation、Partnership）
  '14': 'storePhoto',                  // 店铺图片
  '15': 'bdoBusinessDetails',          // 已经有BDO账号注册
};


const pageMap = {
  SolePropB: {
    pageNo: '1',
  },
  SolePropC: {
    pageNo: '2',
  },
  SolePropD: {
    pageNo: '3',
  },
  SolePropE: {
    pageNo: '4',
  },
  SolePropF: {
    pageNo: '5',
  },
  SolePropG: {
    pageNo: '6',
  },
  SolePropH: {
    pageNo: '9',
  },
  SolePropI: {
    pageNo: '10',
  },
  SolePropJ: {
    pageNo: '11',
  },
  SolePropK: {
    pageNo: '12',
  },
  SolePropL: {
    pageNo: '14',
  },
  SolePropM: {
    pageNo: '999',
  },
  ExistingBDOMerchant: {
    pageNo: '1',
  },
  ExistingBDOPartner: {
    pageNo: '1',
  },
  IndividualB: {
    pageNo: '1',
  },
  IndividualC: {
    pageNo: '2',
  },
  IndividualD: {
    pageNo: '3',
  },
  IndividualE: {
    pageNo: '4',
  },
  IndividualF: {
    pageNo: '5',
  },
  IndividualG: {
    pageNo: '6',
  },
  IndividualH: {
    pageNo: '9',
  },
  IndividualI: {
    pageNo: '10',
  },
  IndividualJ: {
    pageNo: '11',
  },
  IndividualK: {
    pageNo: '14',
  },
  IndividualL: {
    pageNo: '999',
  },
  CorporationB: {
    pageNo: '1',
  },
  CorporationC: {
    pageNo: '2',
  },
  CorporationD: {
    pageNo: '5',
  },
  CorporationE: {
    pageNo: '6',
  },
  CorporationF: {
    pageNo: '7',
  },
  CorporationG: {
    pageNo: '8',
  },
  CorporationH: {
    pageNo: '10',
  },
  CorporationI: {
    pageNo: '11',
  },
  CorporationJ: {
    pageNo: '13',
  },
  CorporationK: {
    pageNo: '14',
  },
  CorporationL: {
    pageNo: '999',
  },
  PartnershipB: {
    pageNo: '1',
  },
  PartnershipC: {
    pageNo: '2',
  },
  PartnershipD: {
    pageNo: '5',
  },
  PartnershipE: {
    pageNo: '6',
  },
  PartnershipF: {
    pageNo: '7',
  },
  PartnershipG: {
    pageNo: '8',
  },
  PartnershipH: {
    pageNo: '10',
  },
  PartnershipI: {
    pageNo: '11',
  },
  PartnershipJ: {
    pageNo: '13',
  },
  PartnershipK: {
    pageNo: '14',
  },
  PartnershipL: {
    pageNo: '999',
  },
  BdoMerchantA: {
    pageNo: '15'
  },
  BdoMerchantB: {
    pageNo: '999'
  }
}

export default Object.keys(pageMap).reduce((acc, item) => {
  const { pageNo } = pageMap[item];

  acc[item] = {
    pageNo,
    fieldWrapper: pageNoMap[pageNo],
  }

  return acc;
}, {});

export const getPageNo = (type, No) => {
  const obj = {
    '1': 'Individual',
    '2': 'SoleProp',
    '3': 'Corporation',
    '4': 'Partnership',
    '5': 'BdoMerchant',
  }
  let name = ""
  for (let i in pageMap) {
    if(i.includes(obj[type]) && pageMap[i].pageNo == No) {
      name = i
    }
  }
  return name
}

export const getPageNoKey = (name) => {
  const excludeData = ['SolePropM', 'ExistingBDOMerchant', 'ExistingBDOPartner', 'IndividualL', 'CorporationL', 'PartnershipL', 'BdoMerchantB' ]
  let pageMaps = {}
  for(let i in pageMap) {
    if(!excludeData.includes(i)) {
      pageMaps[i] = pageMap[i]
    }
  }
  if (name in pageMaps) {
    return { key: pageNoMap[pageMaps[name].pageNo], pageNo: pageMaps[name].pageNo }
  } else {
    return {}
  }
}